<template>
<!-- 订单详情 -->
  <div class="import-orders-view" >
    <div class="biz-type">
      <!-- <ab-svg name="fapiao"></ab-svg> -->
      发票类型：{{dataForm.bizType == '01' ? "13% 增值税专用发票 " : "海关税票+6% 服务费发票 "}}
    </div>

     <div class="tax-limit" v-if="dataForm.taxIsEnabled && dataForm.isTaxesAdvanced">
        <div class="title"> 本次预计垫税</div>  
        <div class="number">{{dataForm.estimateTaxesAmount}} <span class="by">(CNY)</span></div>
     </div>

     <div class="cargoInfo">
        <div class="title">
            <h3>收发货信息</h3>
            <div class="progress" @click="getStatusTimeAxis">
              <div class="text">物流进度</div>
                  <el-progress type="circle" class="number" :percentage="progress"  color="#0A7CFF"  :stroke-width="12" stroke-linecap="butt"/>
            </div>
        </div>
        <div class="consignee clearfix">
            <div class="logo">
                <ab-svg name="jwjiao"></ab-svg>
                <div class="step-line" :style="{'height': stepline()}"></div>
                <div class='normal'></div>
                <div class="jiantou">
                    <ab-svg name="jiantou"></ab-svg>
                </div>
                                
                <ab-svg name="guoneishou"></ab-svg>
            </div>
            <div class="content">
                <div class="content-song">
                    <div class="allSongShou" style="padding-top: 0;">
                      <div class="supplier">供应商</div>
                      <p>{{dataForm.supplierName}}</p>
                    </div>
                    <p class="incoming-div" v-if="dataForm.incomingAddress && dataForm.supplierMethod == '02'">
                      <ab-svg name="dingwei2"></ab-svg>
                        {{incomingRemarks}}
                    </p>
                    <div class="incoming-div"  v-if="dataForm.supplierMethod == '01'">
                      <ab-svg name="dingwei2"></ab-svg>
                      送货地址：香港沙田安平街8号偉達中心8楼樓801室 | 联系人：羅占偉 00852-26089369
                    </div>
                    <div class="deliveryMethod">
                      <el-row >
                        <el-col :span="8" >
                          交货方式：<span v-if="dataForm.supplierMethod">{{supplierOptions.filter(e => { return e.value == dataForm.supplierMethod})[0].desc}}</span>
                        </el-col>
                        <el-col :span="8" v-if="dataForm.supplierMethod == '03' || dataForm.supplierMethod == '04' || dataForm.supplierMethod == '05'">
                        {{ ['','','机场名称','码头名称','保税区名称'][Number(dataForm.supplierMethod) - 1] }}: {{ dataForm.supplierMethodLabel }}
                        </el-col>
                        <el-col :span="8" v-if="dataForm.supplierMethod == '03'">
                        快递公司：{{dataForm.supplierCarrierName}}    快递单号: {{ dataForm.supplierCourierNumber }}
                        </el-col>
                        <el-col :span="8" v-if="dataForm.supplierMethod == '06' && dataForm.supplierMethodAddressId && !isHKchange">
                          需香港清关
                        </el-col>
                      </el-row>
                    </div>
                </div>

                <div class="content-shou">
                  <div class="allSongShou" style="margin-bottom: 20px;" v-if="['02','03'].includes(dataForm.deliveryMethod)">
                        <div class="supplier">收货公司</div>
                        <p>{{dataForm.deliveryCompany}}</p>
                    </div>
                    <div class="receivingAddress" v-if="(dataForm.deliveryAreaNameAndContent || dataForm.deliveryLinkman || dataForm.deliveryContactNumber) && dataForm.deliveryMethod != '01'">
                   <ab-svg name="dingwei"></ab-svg>
                   {{this.dataForm.deliveryAreaNameAndContent}}/{{this.dataForm.deliveryLinkman}}/{{this.dataForm.deliveryContactNumber}}
                </div>
                  <el-row :gutter="25" style="margin-bottom: 40px;" class="deliver-item">
                      <el-col :span="8" ><div>送货方式： <span>{{{'02': '一咻送货', '03': '快递送货', '01': '自提', '04': '待通知', '06': '存仓'}[dataForm.deliveryMethod]}}</span></div></el-col>
                      <!-- <el-col :span="8">多个地址收货：<span > {{dataForm.deliveryIsBatchDelivery ? ' 是' : ' 否'}}</span></el-col> -->
                      <el-col :span="8" v-if="dataForm.deliveryMethod == '02'"><div>签收方式： <span>{{dataForm.deliverySignatureModeDesc}}</span></div></el-col>
                      <el-col :span="8" v-if="dataForm.deliveryMethod == '03'">
                        <div >付费方式：<span > {{dataForm.deliveryPayTypeDesc}}</span></div>
                      </el-col>
                      <el-col :span="8" v-if="(dataForm.deliverySignatureMode === '2' && dataForm.deliveryMethod == '02' || dataForm.deliveryMethod == '01')">
                        <div>身份证号码： <span>{{dataForm.deliveryIdentityNumber}}</span></div>
                      </el-col>
                      <!-- <el-col :span="8" v-if="typeof dataForm.deliveryIsBatchDelivery == 'boolean' && dataForm.deliveryIsBatchDelivery == false">
                        <div>提货公司： <span>{{dataForm.deliveryCompany}}</span></div>
                      </el-col> -->
                      <el-col :span="8"  v-if="dataForm.deliveryMethod == '06' && sourceType != 'out'">
                        <div>仓库：<span>{{dataForm.inRepertoryName}}</span></div>
                      </el-col>

                      <el-col :span="8" v-if="dataForm.deliveryMethod == '01' && sourceType != 'out'">
                        <div>联系人：<span>{{dataForm.deliveryLinkman}}</span></div>
                      </el-col>

                      <el-col :span="8" v-if="dataForm.deliveryMethod == '01' && sourceType != 'out'">
                        <div>联系电话：<span>{{dataForm.deliveryContactNumber}}</span></div>
                      </el-col>
                  </el-row>
                    
                    
                   
                </div>

                
            </div>            
        </div>
     </div>

     <div class="information">
        <el-tabs v-model="activeName" class="client-tabs" @tab-click="handleClick">
          <el-tab-pane label="货物信息" name="01">
              <ab-table 
               stripe
               class="materialTable"
               ref="table1"
               selectionWidth="45"
               indexWidth="50"
               widths="140"
               :column-list="entryColumns"
               :table-list="dataForm.entry"
              >
                <template #model="scope">
                  {{scope.row.model}}<el-tag class="ml-2" type="warning" v-if="modelState(scope.row)">{{modelState(scope.row)}}</el-tag>
                </template>
              </ab-table>
              <el-row>
                <el-col :span="8" v-if="dataForm.costEstimate && dataForm.costEstimate.couponId">
                  <div class="coupons">
                    优惠券 ￥{{$filters.formatMoney(dataForm.costEstimate.couponAmount)}}
                  </div>
                </el-col>
                <el-col :span="8" v-if="dataForm.costEstimate.isUseAcc">
                  <div class="coupons">
                    已用余额 ￥{{$filters.formatMoney(dataForm.costEstimate.accountUseAmount)}}
                  </div>
                </el-col>
              </el-row>
          </el-tab-pane>
          <el-tab-pane label="付汇信息" name="02">
               <ab-table 
                stripe
                class="materialTable"
                ref="table2"
                selectionWidth="45"
                indexWidth="50"
                widths="140"
                showEdit
                :column-list="payColumns"
                :table-list="payList"
                :showSummary="true"
                :summary-method="(param)=>getSummaries(param,['applyAmount','settleAmount','chargesBearer'])"
               >
                 <template #createTime='scope'>
                    <div>
                      <span :class="getStatusClass(scope.row.createTime)"></span>
                      {{ scope.row.createTime }}
                    </div>
                 </template>

                 <template #operator="scope">
                   <el-button type="primary" link v-if="scope.row.paidFile" :loading="dowLoading"  @click="downLoadFile(scope.row)">水单</el-button>
                   <i class="dividingLine"></i>
                   <el-button type="primary" link @click="showPayDetail(scope.row)">详情</el-button>
                 </template>

               </ab-table>
          </el-tab-pane>
          <el-tab-pane label="账单信息" name="03">
            <div>
                <div class="title">
                    <h5>账单信息</h5>
                    <div>
                      <el-button @click="downloadEntry(1)" v-if="dataForm.costEstimate && dataForm.costEstimate.materialUrl" :loading="isloading">下载明细</el-button>
                      <el-button @click="downloadEntry(2)" v-if="dataForm.costEstimate && dataForm.costEstimate.payNoticeUrl"  :loading="isloading">下载通知书</el-button>
                    </div>
                </div>
                <ab-table 
                   stripe
                   class="materialTable"
                   ref="table2"
                   selectionWidth="45"
                   indexWidth="50"
                   widths="140"
                   :column-list="billColumns"
                   :table-list="arSettleEntryVoList"
                   :showSummary="true"
                    :summary-method="(param)=>getSummaries(param,['arAmount', 'writeOffAmount'])"
                   >

                <template #payStatus='scope'>
                    <div>
                      <span
                        :class="{'status-0AB2A8': scope.row.arAmount <=  scope.row.writeOffAmount, 'status-13227A': scope.row.arAmount >  scope.row.writeOffAmount}"
                      >
                      </span>
                      {{ scope.row.arAmount <=  scope.row.writeOffAmount ? '已支付' : '待支付'}}
                    </div>
                </template>
                </ab-table>
            </div>

            <div>
                <h5 class="fapiao">发票信息</h5>
                <ab-table 
                   stripe
                   class="materialTable"
                   ref="table2"
                   showEdit
                   selectionWidth="45"
                   indexWidth="50"
                   widths="180"
                   :column-list="invoicesColumns"
                   :table-list="invoicesData"
                   :showSummary="true"
                   :summary-method="(param)=>getSummaries(param,['invoiceAmount','invoiceCount'])"

                   >

                <template #clientStatusDesc='scope'>
                    <div>
                      <span
                        :class="getStatusClass(scope.row.clientStatusDesc)"
                      ></span>
                      {{ scope.row.clientStatusDesc }}
                    </div>
                </template>

                <template #operator="scope">
                  <el-button type="primary" link @click="nvDownloadFile(scope.row, '010')">合同</el-button>
                  <el-button type="primary" link @click="nvDownloadFile(scope.row, '020')">发票</el-button>
                  <el-button type="primary" link @click="nvoicesDetail(scope.row)">详情</el-button>
              </template>

                 
                </ab-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="评价信息" name="04" v-if="evaluation.id">
            <div class="rate-large">
              服务评价：<el-rate v-model="evaluation.serviceRating" disabled size="large" show-score text-color="#000000" score-template="{value} 分" />
            </div>
            <div class="rate-large">
              物流评价：<el-rate v-model="evaluation.logisticsRating" disabled size="large" show-score text-color="#000000" score-template="{value} 分" />
            </div>
            <div class="rate-user">
              <img :src="evaluation.avatarUrl ? evaluation.avatarUrl : require('../../assets/img/user-1.png')" />
              <div >
                <div>{{evaluation.createByIdDesc}}</div>
                <div>{{evaluation.createTime}}</div>
              </div>
            </div>
            <div class="rate-content">{{ evaluation.evaluationContent }}</div>
            <download-preview :params="uploadParams"></download-preview>
          </el-tab-pane>
        </el-tabs>
        
     </div>
    
    <div v-if="activeName == '01'">
        <el-row class="cargoMoney">
            <el-col>
            <h5>总金额（{{this.dataForm.currencyName}}）</h5>
            <div class="number">{{$filters.formatMoney(dataForm.totalAmount)}}</div>
            </el-col>
            <el-col>
            <h5>总数量</h5>
            <div class="number">{{dataForm.totalQty}}</div>
            </el-col>
            <el-col>
            <h5>总件数</h5>
            <div class="number">{{dataForm.totalPackedQty}}</div>
            </el-col>
            <el-col>
            <h5>总净重（kg）</h5>
            <div class="number">{{dataForm.totalNetWeight}}</div>
            </el-col>
            <el-col>
            <h5>总毛重（kg）</h5>
            <div class="number">{{dataForm.totalGrossWeight}}</div>
            </el-col>
        
        </el-row>

        <el-alert v-if="dataForm.remark" :title="dataForm.remark" type="warning" :closable="false"></el-alert>
      
      <el-drawer v-model="logvisible" title="物流进度">
        <ab-logistics-status ref="logistics-status">
        </ab-logistics-status>
      </el-drawer>
       
    </div>

    

    <ab-attPreview :preview="preview"></ab-attPreview>
  </div>
</template>

<script>
export default {
  data() {
      return {
          supplierOptions: [
            {value: '01', desc: '送货到香港仓（非快递送货）'},
            {value: '06', desc: '送货到香港仓（快递送货）'}, 
            {value: '02', desc: '需香港本地提货'},
            {value: '03', desc: '送货到国内机场'},
            {value: '04', desc: '送货到国内码头'},
            {value: '05', desc: '送货到保税区'}
          ],
          activeName: '01',
          //进度
          progress: 0,
          arSettleEntryVoList: [],
          invoicesData: [],
          payList: [],
          dowLoading: false,
          isloading: false,
          //货物信息
          entryColumns: [
            {
              props: "model",
              labels: "型号",
              widths: 200,
              slot: 'slot'
            },
            {
              props: "brand",
              labels: "品牌",
              widths: 150,
            },
            {
              props: "materialName",
              labels: "货物名称",
              widths: 100,             
            },
            {
              props: "originPlaceName",
              labels: "产地",
              widths: 100,
            },
            {
              props: "qty",
              labels: "数量",
              widths: 100,
            },
            {
              props: "baseUnitName",
              labels: "单位",
              widths: 60,
            },
    
            {
              props: "price",
              labels: '单价',
              widths: 130,
              align: 'right'
            },
            {
              props: "amount",
              labels: "总价",
              widths: 100,
              align: 'right',
              type: 'money',
            },
    
            {
              props: "packedQty",
              labels: "件数",
              widths: 70,
            },
            {
              props: "netWeight",
              labels: "净重（kg）",
              widths: 100,
            },
            {
              props: "grossWeight",
              labels: "毛重（kg）",
              widths: 100,
            },
            {
              props: "custMatNo",
              labels: "料号",
              widths: 100,
            }
          ],
          //付汇信息
          payColumns: [
            {
              props: "clientNumber",
              labels: "付汇申请单",
              widths: 170,
            },
            {
              props: "clientStatusDesc",
              labels: "付款状态",
              align: 'center',
              widths: 80,            
            },
            {
              props: "actualPaymentDate",
              labels: "付款日期",
              align: 'center',
              widths: 100,    
            },
            {
              props: "applyAmount",
              labels: "付款金额",
              widths: 100,
              align: "right",
              type:'money'
            },
            {
              props: "applyCurrencyIdDesc",
              labels: "币别",
              widths: 60,
            },
            {
              props: "settleRate",
              labels: "折算汇率（CNY)",
              widths: 130,
            },
            {
              props: "settleAmount",
              labels: "折算金额(CNY)",
              widths: 120,
              align: "right",
              type:'money'
            },
            {
              props: "chargesBearerCny",
              labels: "手续费（CNY）",
              type: 'money',
              align: 'right',
              widths: 130,
            },
    
            {
              props: "ticketDif",
              labels: "汇差",
              widths: 80,
              type: 'money',
              align: 'right',
            },
            {
              props: "ticketDifSum",
              labels: "累计汇差",
              widths: 80,
              type: 'money',
              align: 'right',
            },
    
            {
              props: "revIdDesc",
              labels: "收款方",
              widths: 150,
            },
            {
              props: "revBankIdDesc",
              labels: "收款银行",
              widths: 150,
            },
            {
              props: "revBankAccount",
              labels: "收款账号",
              widths: 150,
            }
          ],
          
          //账单发票
          billColumns: [
            {
              props: "expenseItemIdDesc",
              labels: "计费项目",
              widths: 100,
            },
            {
              props: "payStatus",
              labels: "支付状态",
              slot: "slot",
              widths: 60,            
            },
            {
              props: "occurAmount",
              labels: "原币金额",
              widths: 100,
              type:'money',
              align: "right",        
            },
            {
              props: "occurCurrencyIdDesc",
              labels: "原币别",
              widths: 80,
              align: "center",        
            },
            {
              props: "settleRate",
              labels: "折算汇率",
              widths: 60,
            },
            {
              props: "arAmount",
              labels: "应付金额（CNY）",
              widths: 100,
              type:'money',
              align: "right",
            },
            {
              props: "adjustReason",
              labels: "备注",
              widths: 150,
              align: "center",
            },
    
            {
              props: "arDate",
              labels: "应付日期",
              widths: 100,
            },
            {
              props: "receiptTime",
              labels: "付款日期",
              widths: 100,
            },
            {
              props: "writeOffAmount",
              labels: "已付金额",
              widths: 100,
              type:'money',
              align: "right",
            },
          ],
          //发票信息
          invoicesColumns: [
            {
              props: "number",
              labels: "申请单号",
              widths: 120,
            },
            {
              props: "clientStatusDesc",
              labels: "开票状态",
              slot: "slot",
              widths: 100,            
            },
            {
              props: "invoiceTimeStr",
              labels: "开票日期",
              widths: 100,    
            },
            {
              props: "invoiceAmount",
              labels: "开票金额",
              widths: 100,   
              type:"money",
              align: "right", 
            },
            {
              props: "taxRate",
              labels: "税率",
              widths: 100,
              align:'center'       
            },
            {
              props: "tax",
              labels: "税额",
              widths: 60,
              type:"money",
              align: "right", 
            },
            {
              props: "invoiceNumber",
              labels: "发票号码",
              widths: 100,
            },
            {
              props: "invoiceCount",
              labels: "发票份数",
              widths: 100,
            },
    
            {
              props: "signStatusDesc",
              labels: "合同状态",
              widths: 100
            },
          ],
          logvisible: false,
          preview: {
            show: false,
            sourceBillType: 'PaymentApp'
          },
          uploadParams: {
            coreBillIds: "",
            coreBillNumbers: "",
            sourceBillId: "",
            sourceBillNumber: "",
            sourceBillType: "EntrustAll",
            billsType: "",
            items: [
              {
                title: "",
                attachType: "120",
                required: false,
              }
            ]
          },
          evaluation: {}
      }
  },
  props: {
    dataForm: {
      type: Object,
      default: {}
    }
  },
  computed: {
    sidebarFold: {
      get() {
        return this.$store.state.sidebarFold;
      },
    },
    incomingRemarks: {
      get () {
          return '提货地址：' + this.dataForm.incomingAreaIdName + '-' + this.dataForm.incomingAddress  + '  联系人：' + this.dataForm.incomingLinkman + '  电话：' + this.dataForm.incomingContactNumber + '  提货时间:' + this.dataForm.incomingTime +  ' 件数:' + (this.dataForm.incomingTotalPackedQty || '') + (this.dataForm.incomingRemark ? ` 入仓号：${this.dataForm.incomingRemark}` : '')
      },
      set (val) {
          this.incomingRemarks = val
      }
    },
    isHKchange () {
      if (this.dataForm.supplierMethodAddressId && this.dataForm.supplierMethodAddressId[1] == '4794175053496320') {
          return true
      } else {
          return false
      }
    },
  },
  watch: {
    "dataForm.id": {
      handler: function () {
        this.activeName = '01'
        if (this.dataForm.id) {
          this.initAxis()
        }
        if (this.dataForm.currencyName) {
          this.entryColumns.map(e => {
            if (e.props == 'price') {
              e.labels = `单价（${this.dataForm.currencyName}）`
            }
          })
        }
        this.uploadParams.sourceBillId = this.dataForm.id
        this.getEvaluationByParentId()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //付款状态判断条件
    getStatusClass(val) {
      let cls = "";
      switch (val) {
        case "已退回":
          cls = "status-E21010";
          break;
        case "签署中":
          cls = "status-13227A";
          break;
        case "已申请":
          cls = "status-0AB2A8";
          break;
        case "待审核":
          cls = "status-0A7CFF";
          break;
        case "已审核":
          cls = "status-0AB2A8";
        break;
        case "已开票":
          cls = "status-1165D4";
        break;
        case "已作废":
          cls = "status-B1B1B1";
        break;
        case "已寄出":
          cls = "status-FF8400";
        break;  
      }
      return cls;
    },
    //表格合计
    getSummaries(param,value) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          let val= value.indexOf(column.property) != -1
          if(val){
            const values = data.map(item => Number(item[column.property]))
            sums[index]= values.reduce((prev, curr) => {
                const value = Number(curr)
                if (!isNaN(value)) {
                      return this.$calc.add(prev, curr)
                    } else {
                      return prev
                    }
            }, 0)
            if (column.property != 'invoiceCount') {
              sums[index] = this.$filters.formatMoney(sums[index])
            }
          }
        });
        return sums;
    },
    handleClick (val) {
      setTimeout(() => {
        if (this.activeName == '03') {
          this.drawInvoiceList()
        } else if (this.activeName == '02') {
          this.getPaymentList()
        }
        this.$emit('checkedUpload', this.activeName)
      }, 50)
      
    },
    getStatusTimeAxis () {
      this.logvisible = true
      setTimeout(() => {
        this.$refs['logistics-status'].getStatusTimeAxis(this.dataForm.id, this.dataForm.bizType)
      }, 500)
    },
    drawInvoiceList () {
      if (this.dataForm.costEstimate && this.dataForm.costEstimate.arSettleEntryVoList && this.dataForm.costEstimate.arSettleEntryVoList.length) {
          this.arSettleEntryVoList = this.dataForm.costEstimate.arSettleEntryVoList
      } else {
        this.arSettleEntryVoList = []
      }
      if (this.dataForm.custOrderNo) {
        this.$post('/fms/client/drawInvoice/pageList', {pageNum: 1,pageSize: 10,data: {custOrderNo: this.dataForm.custOrderNo}}).then(({data}) => {
            if (data && data.code == 'C0000') {
              this.invoicesData = data.result.list
              this.invoicesData.map(e => {
                if (e.taxRate) {
                  e.taxRate += '%'
                }
              })
            }
        })
      }
    },
    getPaymentList () {
      this.$post('/sms/client/paymentApp/list', {data: {number: this.dataForm.custOrderNo, entrustType: "import"}, pageNum: 1, pageSize: 20}).then(({data}) => {
        if (data && data.code == 'C0000') {
          this.payList = data.result.list
        }
      })
    },
    initAxis () {
      this.$post('/oms/client/entrustStatus/getStatusTimeAxis', { entrustId: this.dataForm.id, bizType: this.dataForm.bizType, isShowOut: true }).then(({ data }) => {
        if (data && data.code == 'C0000') {
          this.progress = data.result[0].progress
        }
      })
    },
    nvDownloadFile (row, type) {
      this.$post('/oms/billAttach/compress', {sourceBillId: row.id, attachType: type}).then(({data}) => {
        if (data && data.code == 'C0000') {
            console.log(data.result)
            let eleLink = document.createElement('a')
            eleLink.download = ''
            eleLink.style.display = 'none'
            // 字符内容转变成blob地址
            eleLink.href = data.result
            // 触发点击
            document.body.appendChild(eleLink)
            eleLink.click()
            // 然后移除
            document.body.removeChild(eleLink)
            
        }
      })
    },
    nvoicesDetail (row) {
      this.$router.push({
          path: '/invoice-detail',
          query: {
              action: 'detail',
              id: row.id,
          },
      })
    },

    downLoadFile (row) {
      this.preview.sourceBillId = row.id
      this.preview.attachType = '020'
      this.preview.show = true

      // if(!row || !row.paidFile) {
      //     this.$message({
      //         type: 'warning',
      //         message: '该条单据没有上传附件数据',
      //         offset: 380,
      //         grouping: true,
      //     })                                          
      //     return
      // }
      // this.dowLoading = true
      // this.$get('/sms/paymentApp/downloadPaidFiles', {id: row.id}).then((res) => {
      //     if (res.data && res.data.code === 'C0000') {
      //         let eleLink = document.createElement('a')
      //         eleLink.download = ''
      //         eleLink.style.display = 'none'
      //         // 字符内容转变成blob地址
      //         eleLink.href = res.data.result
      //         // 触发点击
      //         document.body.appendChild(eleLink)
      //         eleLink.click()
      //         // 然后移除
      //         document.body.removeChild(eleLink)
      //     }
      // }).finally(() => {
      //   this.dowLoading = false
      // })
    },
    modelState (row) {
      let str = ''
      if (row.importTariffRate && row.importTariffRate != 0) {
        str = '关 ' + row.importTariffRate + '%'
      }
      if (row.inspectionQuarantine && (row.inspectionQuarantine.indexOf('A') != -1 || row.inspectionQuarantine.indexOf('L'))) {
        str += '| 检'
      }
      return str
    },
    downloadEntry (str) {
      this.isloading = true
      let url = ''
      if (str == 1) {
        url = this.dataForm.costEstimate.materialUrl
      } else {
        url = this.dataForm.costEstimate.payNoticeUrl
      }
      window.open(url)
      setTimeout(() => {
        this.isloading = false
      }, 500)
       
    },
    showPayDetail (row) {
      this.$router.push({
        path: '/pledging-payment-detail',
        query: {
          action: 'view',
          id: row.id
        }
      })
    },
    stepline () {
      let str = '43px'
      if (this.dataForm.deliveryIsBatchDelivery) {
        str = '57px'
      }
      if (this.dataForm.supplierMethod == '01' || this.dataForm.supplierMethod == '02') {
        str = '65px'
        if (this.dataForm.deliveryMethod == '02' || this.dataForm.deliveryMethod == '03') {
          str = '85px'
        }
      } else if (!(this.dataForm.deliveryMethod == '02' || this.dataForm.deliveryMethod == '03')){
        str = '25px'
      }
      return str
    },
    //订单评价信息
    getEvaluationByParentId () {
      this.$get('/oms/entrustImportEvaluation/getByParentId', {id: this.dataForm.id}).then(({data}) => {
        if (data && data.code == 'C0000') {
          this.evaluation = data.result || {}
        }
      })
    }
  },
};
</script>

<style lang='scss'>
.import-orders-view {
  padding-bottom: 0px;
  text-align: left;
  border-top: 1px solid #f0f2f5;
  color: #000000;
  font-weight: 400;

  .cargoInfo {
    .el-col {
      line-height: 19px!important;
    }
  }

  .incoming-div {
    margin: 20px 0;
    .icon-svg {
        width: 11px;
        height: 16px;
        vertical-align: middle;
    }
  }
  
  
  .biz-type {
    height: 35px;
    line-height: 35px;
    background-color: #f2f7ff;
    border-radius: 0 0 8px 8px;
    width: 270px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    .icon-svg {
      vertical-align: middle;
      width: 13px;
      height: 15px;
    }
  }

  .tax-limit {
    width: 433px;
    height: 80px;
    padding: 15px 20px;
    margin-top: 30px;
    background: #F2F7FF;
    border-radius: 16px;
    .title{
        font-size: 14px; 
        margin-bottom: 4px;
    }
    .number{
        font-size: 24px;
        color:#F87243 ;
        line-height: 1.5;
        .by {
            font-size: 14px;
        }
    }
    
  }

  .cargoInfo{ 
    border-bottom: 1px solid #F0F2F5;
    .title{
        display: flex;
        justify-content: space-between;
        padding: 20px 0 ;
        h3{
           color: #000000;
           line-height: 40px;
           font-size: 18px;
        }
        .progress{
            width: 125px;
            height: 45px;
            border: 1px solid #C4C6CF;
            cursor: pointer;
            border-radius:22.5px;
            line-height: 45px;
            padding-left: 15px;
            .el-progress.el-progress--circle{
                top: -46px;
                right: -65px;
                .el-progress-circle{
                    width: 45px !important;
                    height: 45px !important;
                    .el-progress-circle__track{
                        stroke: #C4C6CF;
                    }
                }
                .el-progress__text{
                    font-weight: bold;
                    font-size: 14px !important;
                    color: #0A7CFF;
                }
                
            }
            .text{
                font-size: 14px;
                color: #111111;
            }
        }
    }
    .logo{
        float: left;
        width: 54px;
        .icon-svg {
            width: 54px;
            height: 74px;
        }
        .step-line {
            width: 2px;
            height: 55px;
            background: linear-gradient(to bottom, #88B2E9, #88B2E9 7.5px, transparent 7.5px, transparent);
            background-size: 100% 15px;
            margin-left: 26px;
        }
        .jiantou {
        height: 12px;
        text-align: center;
        .icon-svg {
            vertical-align: super;
            width: 12px;
            height: 12px;
           }
        }
    }
    .content{
        float: left;
        margin-left: 40px;
        width: calc(100% - 95px);
        
        .allSongShou{
                width: 100%;
                display: flex;
                padding: 20px 0 20px;
                line-height: 24px;              
                .supplier{
                    padding: 5px 15px;
                    height: 24px;
                    line-height: 14px;
                    border-radius: 4px;
                    background-color: #F0F2F5;   
                    font-size: 14px;               
                }                
                p{
                    font-size: 22px;
                    font-weight: bold; 
                    margin-left:20px ;                   
                }
          border-bottom: 1px solid #F0F2F5;
        }
        .content-song{
            
            .deliveryMethod{
                font-size: 14px;
                margin-top: 30px;
                line-height: 1;
            }
            
        }
        .content-shou{
            margin-top: 30px;
            // border-bottom: 1px solid #F0F2F5;
            .content-shou-info{
                display: flex;
                font-size: 14px;
                &>div{
                    width:calc(100% / 3) ;
                }
            }
            .el-col {
              line-height: 30px!important;
              div{
                line-height: 1;
              }
            }
        }
        .receivingAddress{
            font-size: 14px;
            font-weight: 400;
            margin:18px 0 30px;
            .el-icon{
                vertical-align: middle;
            }
        }
    }
  }

  .information{
    margin-bottom: 40px;
    .el-tabs__header {
      margin-bottom: 20px;
      margin-top: 30px;
    }
    .materialTable {
      margin-top: 20px;
    }
     /*去掉切换时el-tab-pane底部的蓝色下划线*/
    .el-tabs__active-bar {
      background-color: transparent !important;
    }
    /*去掉tabs底部的下划线*/
    .el-tabs__nav-wrap::after {
      position: static !important;
    }
    .el-tabs__item.is-top {
      padding: 0;
      margin-right: 40px;
      font-size: 16px;
      &.is-active {
        background-image: url(@/assets/img/nav-active.png);
        background-repeat: no-repeat;
        background-position: bottom;
        border-bottom: none;
        font-size: 18px;
      }
    }
    .dividingLine {
      display: inline-block;
      width: 1px;
      height: 10px;
      background-color: #bfbfbf;
      margin: 0 5px;
    }
    .el-table__footer-wrapper{
        td{
            color: #000000;
        }
    }
    h5{
        margin-bottom:30px;
    }
    .title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom:15px;
        font-size: 16px;
        h5{
            margin: 0;
        }
    }
    .fapiao{
        margin-top: 30px;
        font-size: 16px;
    }
  }
  
  .cargoMoney{
   margin-bottom: 40px;
   & > div{
       flex: 1;
       h5{
           font-size: 14px;
           font-weight: 400;
           margin-bottom: 15px;
       }
       div{
           font-size: 30px;
           font-weight: 500;
       }
   }
  }

  .el-alert{
    background-color: #FEEAE3;
    color:#F87243 ;
    span{
        font-size: 14px;
    }
    margin-bottom: 40px;
  }

  .upload {
   margin: 40px 0;
     h5 {
       margin-bottom: 10px;
       font-size: 14px;
     }
     
     & > div {
       display: flex;
       justify-content: space-between;
       .displaybox {
         width: 100%;
         height: 45px;
         padding: 5px;
         margin-left: 20px;
         background-color: #f0f2f5;
         border-radius: 6px;
         div {
           display: inline-block;
           padding: 0 8px 0 15px;
           margin-right: 7px;
           height: 35px;
           line-height: 35px;
           background-color: #fff;
           border-radius: 8px;
           span {
             margin-right: 30px;
           }
           .icon-svg {
             width: 19px;
             height: 19px;
             vertical-align: middle;
             cursor: pointer;
           }
           .one {
             margin-right: 7px;
           }
         }
       }
     }
  }

  .footer {
      margin: 20px;
      text-align: center;
  }
  .mg-t20 {
    margin-top: 20px;
  }
  .ml-2 {
    margin-left: 5px;
    border-radius: 8px;
    color: #F87243;
    background-color: #FEEAE3;
  }
  .rate-user {
    img {
      height: 60px;
      width: 60px;
      border-radius: 50%;
    }
    display: flex;
    align-items: center;
    div {
      margin-left: 10px;
    }
  }
  .rate-large {
    display: flex;
    align-items: center;
    .el-rate {
      --el-rate-fill-color: #f34545;
    }
  }
  .rate-content {
    margin: 20px 0;
  }
  .coupons {
    margin: 20px 0;
  }

}
</style>